import { render, staticRenderFns } from "./DepositStatementComponent.vue?vue&type=template&id=03cb6164&scoped=true"
import script from "./DepositStatementComponent.vue?vue&type=script&lang=js"
export * from "./DepositStatementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb6164",
  null
  
)

export default component.exports